goog.provide("shadow.js.shim.module$src$svg$path$tree_vertical_svg");
goog.provide("module$shadow_js_shim_module$src$svg$path$tree_vertical_svg");
shadow.js.shim.module$src$svg$path$tree_vertical_svg = shadow.js.nativeProvides["src/svg/path/tree-vertical.svg"] = shadow$bridge("src/svg/path/tree-vertical.svg");
module$shadow_js_shim_module$src$svg$path$tree_vertical_svg.default = shadow.js.shim.module$src$svg$path$tree_vertical_svg;
